import http from 'core/services/http';
import Config from 'core/config';
import axios from 'axios';
import isObject from 'lodash';
import { toQueryString } from 'shared/helpers';

class RoomBuilderService {
  static getRoomOptions(cycleId) {
    return axios.all([
      http.get(`${Config.apiUrl}/capacitytypes?cycleId=${cycleId}`),
      http.get(`${Config.apiUrl}/seatings`),
      http.get(`${Config.apiUrl}/desktypes`),
      http.get(`${Config.apiUrl}/supervisordesk`),
      http.get(`${Config.apiUrl}/shapes`),
      http.get(`${Config.apiUrl}/facilities`),
    ]);
  }

  static getRooms() {
    return http.get(`${Config.apiUrl}/room`);
  }

  static getRoomAllInfo(roomId) {
    return http.get(`${Config.apiUrl}/roomAllInfo/${roomId}`);
  }

  static getRoom(roomId) {
    return http.get(`${Config.apiUrl}/room/${roomId}`);
  }

  static createRoom(room) {
    return http.post(`${Config.apiUrl}/room`, room);
  }

  static updateRoom(room) {
    return http.put(`${Config.apiUrl}/room`, room);
  }

  static updateRoomTypeTiming(roomId, data) {
    return http.put(`${Config.apiUrl}/room/${roomId}/typetiming`, data);
  }

  static deleteRoom(roomId) {
    return http.delete(`${Config.apiUrl}/room/${roomId}`);
  }

  static getPastEvents(testCenterCycleId, eventId, params) {
    const queryString = params && isObject(params) ? `?${toQueryString(params)}` : '';
    return http.get(`${Config.apiUrl}/testcentercycle/${testCenterCycleId}/event/${eventId}/cycleevents${queryString}`);
  }

  static copyRooms(targetEventId, data) {
    return http.post(`${Config.apiUrl}/testcenterevent/${targetEventId}/copyroom`, data);
  }

  static updateRoomStatus(roomId, data) {
    return http.put(`${Config.apiUrl}/room/${roomId}/status`, data);
  }

  static submitRoomRanges(roomId) {
    return http.post(`${Config.apiUrl}/room/${roomId}/submitranges`);
  }

  static checkRoomMismatch(room) {
    return http.post(`${Config.apiUrl}/roommismatch`, room);
  }
  
  static getRoomDTO(roomId) {
    return http.get(`${Config.apiUrl}/room/${roomId}/minimaldto`)
  }

  static checkRoomNameExistence(locEvId, roomName) {
    return http.get(`${Config.apiUrl}/locationevent/${locEvId}/room-existence?name=${roomName}`)
  }
}

export default RoomBuilderService;
